import React from "react";
import { useParams } from "react-router-dom";
import { useGetOrdersByIdQuery } from "../slices/OrdersSlice";
import OrderConfirmationScreen from "./OrderConfirmationScreen";
import { useSelector } from "react-redux";

const OrderDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { orderId } = useParams();
  const {
    data: orderDetails,
    error,
    isLoading,
  } = useGetOrdersByIdQuery({ orderId, token: userInfo.token });
  console.log("orderDetails");
  console.log(orderDetails);
  return (
    <>
      <OrderConfirmationScreen propOrder={orderDetails} />
    </>
  );
};

export default OrderDetailsScreen;
